import React from "react";
import axios from "axios";

import YasamanAsakerehImage from "../../../../../assets/yasaman-asakereh-en.png";

class YasamanAsakerehEn extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sendMessage: "Hello,I'mInYasamanAsakerehPageEn",
    };
  }

  componentDidMount = () => {
    this.handleRedirect();
  };

  //put this function in the related component in componentDidMount
  async handleRedirect() {
    const response = await axios.post("https://request.kidiar.com/pages/request", {
      sendMe: this.state.sendMessage,
    });
  }

  render() {
    return (
      <div className="main-body">
        <div className="about-title d-ltr">
          <h1>Hi Yasi, we are working on your page</h1>
          <h1>You will be surprised soon ...</h1>
          <h3>We are proud to have you in our team</h3>
        </div>
        <div className="about-body">
          <img
            src={YasamanAsakerehImage}
            style={{ maxWidth: "90%", marginTop: "-10%" }}
          ></img>
        </div>
      </div>
    );
  }
}

export default YasamanAsakerehEn;
